import template from './report_company_hierarchy.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class CompanyHierarchyViewModel
{
	constructor (page)
	{
		this.page = page;
		this.loader = ko.observable(false);

		this.search_string = ko.observable('');
		this.include_resigned = ko.observable(false);

		this.table_report = ko.observableArray();
		this.download_data = ko.observableArray();
		this.managers = ko.observableArray();
		this.current_department_id = ko.observable();
		this.current_company_id = ko.observable();
		this.manager_id = ko.observable();

		this.selected_company = ko.observable();
		this.selected_department = ko.observable();
		this.selected_manager = ko.observable();

		this.sort_field = ko.observable('surname');
		this.sort_order = ko.observable('ASC');
		this.current_page_number = ko.observable(1);
		this.current_page_size = ko.observable(10);
		this.page_count = ko.observable(1);
		this.pagination_summary = ko.observable('');
		this.number_of_records = ko.observableArray([10, 20, 50, 100]);
		this.selected_number_of_records = ko.observable(10);	
        // Subscriptions
		this.selected_number_of_records.subscribe((newVal) => {
			this.current_page_size(newVal);
			this.page.loadTable();
		});

		this.selected_company.subscribe((newValue) => {
			if (newValue != null)
			{
				this.current_company_id(newValue.company_id);
				this.page.updateData();
			}
			else
			{
				this.current_company_id(null);
				this.page.updateData();
			}
		});

		this.selected_department.subscribe((newValue) => {
			if (newValue != null)
			{
				this.current_department_id(newValue.department_id);
				this.page.updateData();
			}
			else
			{
				this.current_department_id(null);
				this.page.updateData();
			}
		});

		this.selected_manager.subscribe((newValue) => {
			if (newValue != null)
			{
				this.manager_id(newValue.employee_id);
				this.page.updateData();
			}
			else
			{
				this.manager_id(null);
				this.page.updateData();
			}
		});

		this.search_string.subscribe((newValue) => {
			if (newValue == '')
				this.managers([]);
			else
				this.page.get_manager(newValue);
		});

		this.placeholderText = ko.pureComputed(() => {
			return this.selected_manager() != null ? `Selected manager: ${this.selected_manager().firstname} ${this.selected_manager().surname}` : "Search manager...";
		});

		this.include_resigned.subscribe((newText) => {
			this.page.updateData();
		});
	}

	sort_column(column)
	{
		if (column && column.trim() !== '') {
			if (this.sort_field() === column) {
				this.sort_order(this.sort_order() === 'ASC' ? 'DESC' : 'ASC');
			} else {
				this.sort_field(column);
				this.sort_order('ASC');
			}
			this.page.loadTable();
		}
	}

	page_click(page_number)
	{
		this.current_page_number(page_number);
		this.page.loadTable();
	}

	manager_click (selected)
	{
		this.selected_manager(selected);
		this.search_string('');
	}

	clear_selected_option ()
	{
		this.selected_manager(null);
		this.search_string('');
	}

	show_report_help()
	{
		Grape.dialog.open('ManagerSubordinateStructureHelp', { 'employee_id': this.page.bindings.id }, {});
	}

	async download_clicked(v, e)
	{
		let my_manager_employee_options = {
			table: 'v_active_manager_employee',
			schema: 'savanna',
			offset: 0,
			limit: 1000000000,
			sortfield: 'surname',
			sortorder: 'ASC'
		};

		my_manager_employee_options.filter = [{
			value: !this.include_resigned(),
			operand:'=',
			field: 'active'
		}];

		if (this.manager_id())
		{
			my_manager_employee_options.filter.push({ 
				value: this.manager_id(),
				operand: '=',
				field: 'manager_employee_id'
			});
		}

		if (this.current_company_id())
		{
			my_manager_employee_options.filter.push({
				value: this.current_company_id(),
				operand: '=',
				field: 'company_id'
			});
		}

		if (this.current_department_id())
		{
			my_manager_employee_options.filter.push({
				value: this.current_department_id(),
				operand: '=',
				field: 'department_id'
			})
		}

		let res = await Grape.fetches.getJSON('/api/record',my_manager_employee_options);

		if (res)
		{
			if (res.records != null)
			{
				this.download_data(res.records);
				let csv_string = await Utils.table_to_csv(document.getElementById('tbl_employees_hidden'));

				if (csv_string === null || csv_string === undefined || csv_string === '')
					return;

				let blob = new Blob([csv_string], { type: 'text/csv;charset=utf-8;' });
				let link = document.createElement('a');

				link.href = URL.createObjectURL(blob);
				link.setAttribute('download', 'company_hierarchy_report.csv');

				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}
	}
}

class CompanyHierarchyPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new CompanyHierarchyViewModel(this);
	}

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('CompanyEmployeesManagerReport'))
			return;

		document.title = tr('Manager-Employee Overview');
		window.current_page_title(tr('Manager-Employee Overview'));
	}

	updateData()
	{
		this.loadTable();
	}

	async loadTable() {
        this.viewModel.loader(true);
        let options = {
            table: 'v_all_manager_employee',
            schema: 'savanna',
            offset: (this.viewModel.current_page_number() - 1) * this.viewModel.current_page_size(),
            limit: this.viewModel.current_page_size(),
            sortfield: this.viewModel.sort_field(),
            sortorder: this.viewModel.sort_order(),
            filter: [{
                value: !this.viewModel.include_resigned(),
                operand: '=',
                field: 'active'
            }]
        };

        if (this.viewModel.manager_id()) {
            options.filter.push({
                value: this.viewModel.manager_id(),
                operand: '=',
                field: 'manager_employee_id'
            });
        }

        if (this.viewModel.current_company_id()) {
            options.filter.push({
                value: this.viewModel.current_company_id(),
                operand: '=',
                field: 'company_id'
            });
        }

        if (this.viewModel.current_department_id()) {
            options.filter.push({
                value: this.viewModel.current_department_id(),
                operand: '=',
                field: 'department_id'
            });
        }

        let res = await Grape.fetches.getJSON('/api/record', options);
        if (res && res.records != null) {
            this.viewModel.table_report(res.records);
            this.viewModel.page_count(Math.ceil(res.total / this.viewModel.current_page_size()));
            this.viewModel.pagination_summary(
                `Showing ${(this.viewModel.current_page_number() - 1) * this.viewModel.current_page_size() + 1} to ${Math.min(this.viewModel.current_page_number() * this.viewModel.current_page_size(), res.total)} of ${res.total} entries`
            );
        }
        this.viewModel.loader(false);
    }

    async get_manager(value) {
        let options = {
            table: 'v_manager_department',
            schema: 'savanna',
            limit: 10000,
            filter: [],
            filter_join: 'OR'
        };

        if (this.viewModel.search_string() && this.viewModel.search_string() != '') {
            options.filter.push(
                {
                    field: 'firstname',
                    operand: 'ILIKE',
                    value: `%${this.viewModel.search_string()}%`
                },
                {
                    field: 'surname',
                    operand: 'ILIKE',
                    value: `%${this.viewModel.search_string()}%`
                }
            );
        }

        let result = await Grape.fetches.getJSON('/api/record', options);
        if (result.status != 'ERROR' && result.records != null) {
            let current_company_id = this.viewModel.current_company_id();
            let current_department_id = this.viewModel.current_department_id();
            let include_resigned = this.viewModel.include_resigned();
            let filtered_records = result.records.filter(record => {
                let match_company = !current_company_id || record.company_id == current_company_id;
                let match_department = !current_department_id || record.department_id == current_department_id;
                let match_active = include_resigned || record.active == true;
                return match_company && match_department && match_active;
            });
            this.viewModel.managers(filtered_records);
        } else {
            this.viewModel.managers([]);
        }
    }
}

export default {
	route: '[/]report/report_company_hierarchy',
	page_class: CompanyHierarchyPage,
	template: template,
	template_filename: 'translation/report_company_hierarchy'
};
